import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MsgToCar, PresetMessages, SelectTagCar } from "../MapStyled";
import { useHookstate } from "@hookstate/core";
import { useDispatch, useSelector } from "react-redux";
import MembercarIcon from "assets/svgIcons/CarType/MembercarIcon";
import SpecialNeedsIcon from "assets/svgIcons/CarType/SpecialNeeds";

import {
  COMMON_COMPONENTS_STATES,
  MAP_GLOBAL_STATES,
  CAR_NUMBER_MESSAGE,
} from "globalStore/globalStore";
import {
  Tooltip,
  Checkbox,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormGroup,
} from "@mui/material";

import CloseIcon from "../../../../../assets/svgIcons/CloseIcon";
import CheckIcon from "assets/svgIcons/CheckIcon";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { uuid } from "_helperFunctions/uuid";
import TimeFilterIcon from "assets/svgIcons/TimeFilterIcon";
import BatteryFilterIcon from "assets/svgIcons/BatteryFilterIcon";
import FilterCarIcon from "assets/svgIcons/FilterCarIcon";
import FilterFlagIcon from "assets/svgIcons/FilterFlagIcon";
import FilterShildIcon from "assets/svgIcons/FilterShildIcon";
import FilterDineIcon from "assets/svgIcons/FilterDineIcon";
import FilterBlockIcon from "assets/svgIcons/FilterBlockIcon";
import FilterTagsIcon from "assets/svgIcons/NotCommunicating";
import SearchIcon from "assets/svgIcons/SearchIcon";
import MsgArrowIcon from "assets/icons/FilterIcon/msg-arrow-icon.png";
import PlusIcon from "assets/svgIcons/PlusIcon";

import RadioCheckIcon from "assets/svgIcons/RadioCheckedIcon";
import RadioUncheckIcon from "assets/svgIcons/RadioUncheckIcon";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { useFilteredCarsHook } from "customHooks/useFilterData";
import { isUserAdmin, isUserSupport, getFeatureSetOption, getFeaturesList, carType, isUserReadOnly, memberCarTrackingLevel } from "constant";

// Icons Import End

let filteredData = [];

export const MessageWindowComponent = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const [fleetCars, setFleetCars] = useState(true);
  const [specialCars, setSpecialCars] = useState(true);
  const [marshalCars, setMarshalCars] = useState(true);
  const [beverageCars, setBeverageCars] = useState(true);
  const [notInUseCars, setNotInUseCars] = useState(true);
  const [carsNotCommunicating, setCarsNotCommunicating] = useState(true);
  const [searchInput, setSearchInput] = useState("");
  const [filteredCarsArray, setFilteredCarsArray] = useState([]);
  const [highlightCar, setHighlightCar] = useState([]);
  const [highlightGpsiCarIds, setHighlightGpsiCarIds] = useState([]);
  const [messageInput, setMessageInput] = useState("");
  const [showPresetMessage, setShowPresetMessage] = useState(false);
  const [priority, setPriority] = useState(false);
  const [alert, setAlert] = useState(false);
  const [okResponse, setOkResponse] = useState(false);
  const [yesNoResponse, setYesNoResponse] = useState(false);
  const [noneResponse, setNoneResponse] = useState(true);
  const [paceWarningState, setPaceWarningState] = useState(false);
  const [paceCriticalState, setPaceCriticalState] = useState(false);
  const [batteryWarningState, setBatteryWarningState] = useState(false);
  const [batteryCriticalState, setBatteryCriticalState] = useState(false);
  const { showTagCarsState, showMessageWindowState } = useHookstate(COMMON_COMPONENTS_STATES);
  const { carsDataMessages } = useHookstate(CAR_NUMBER_MESSAGE);
  const [buttonDetector, setButtonDetector] = useState(true);

  const dispatch = useDispatch();

  const { cannedMessagesData, getUserRole, siteSettingsData } = useSelector((state) => state.commonReducers) || [];

  const {
    filterEnableDisable,
    showTaggedCar,
  } = useHookstate(MAP_GLOBAL_STATES);

  const enableMemberCar = (isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role) || (!getFeatureSetOption(
    siteSettingsData?.Features,
    getFeaturesList().member_cars
  ) &&  siteSettingsData?.MemberCarTrackingLevel != memberCarTrackingLevel.Never));

  const [memberCars, setMemberCars] = useState(enableMemberCar);
  const [memberSpecialCars, setMemberSpecialCars] = useState(enableMemberCar);
  
  const { getSelectedCarsState } = useFilteredCarsHook({
    marshalCars: marshalCars,
    specialCars: specialCars,
    memberCars: memberCars,
    memberSpecialCars: memberSpecialCars,
    beverageCars: beverageCars,
    fleetCars: fleetCars,
    notInUseCars: notInUseCars,
    notCommunicatingCars: carsNotCommunicating,
    paceWarning: paceWarningState,
    paceCritical: paceCriticalState,
    batteryWarning: batteryWarningState,
    batteryCritical: batteryCriticalState,
    carsInEnergySaverMode: true
  });

  useEffect(() => {
    dispatch(COMMON_SERVICES.getCannedMessagesServices(siteId.get()));
  }, [siteId.get()]);

  useEffect(() => {
    if (messageInput !== "") {
      setButtonDetector(false);
    } else {
      setButtonDetector(true);
    }
  }, [priority, alert, noneResponse, okResponse, yesNoResponse, messageInput]);

  useState(() => {
    dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
  }, [siteId.get()]);

  useEffect(() => {
    setFilteredCarsArray([
      { carName: "fleetCars", carType: 1, checked: true },
      { carName: "specialCars", carType: 3, checked: true },
    ]);
  }, []);

  useEffect(() => {
    if (filteredCarsArray && filteredCarsArray.length > 0) {
      filterEnableDisable.set(filteredCarsArray);
    } else {
      filterEnableDisable.set([]);
      setFilteredCarsArray([
        { carName: "fleetCars", carType: 1, checked: true },
        { carName: "specialCars", carType: 3, checked: true },
      ]);
    }
  }, [filteredCarsArray]);

  const carStatusData = [
    {
      id: 1,
      iconName: (
        <TimeFilterIcon
          bg={
            paceWarningState
              ? "var(--theme-background)"
              : "var(--input-background)"
          }
          color="#FFE500"
          stroke={
            paceWarningState
              ? "var(--theme-background)"
              : "var(--side-nav-btn-border-color)"
          }
        />
      ),
    },

    {
      id: 2,
      iconName: (
        <TimeFilterIcon
          bg={
            paceCriticalState
              ? "var(--theme-background)"
              : "var(--input-background)"
          }
          color="#FA3C30"
          stroke={
            paceCriticalState
              ? "var(--theme-background)"
              : "var(--side-nav-btn-border-color)"
          }
        />
      ),
    },

    {
      id: 3,
      iconName: (
        <BatteryFilterIcon
          bg={
            batteryWarningState
              ? "var(--theme-background)"
              : "var(--input-background)"
          }
          color="#FFE500"
          stroke={
            batteryWarningState
              ? "var(--theme-background)"
              : "var(--side-nav-btn-border-color)"
          }
        />
      ),
    },

    {
      id: 4,
      iconName: (
        <BatteryFilterIcon
          bg={
            batteryCriticalState
              ? "var(--theme-background)"
              : "var(--input-background)"
          }
          color="#FA3C30"
          stroke={
            batteryCriticalState
              ? "var(--theme-background)"
              : "var(--side-nav-btn-border-color)"
          }
        />
      ),
    },
  ];
  const showFilteredCars = (carName, carType, carTypeState) => {
    if (!carTypeState) {
      setFilteredCarsArray([
        ...filteredCarsArray,
        { carName, carType, checked: !carTypeState },
      ]);
    } else {
      setFilteredCarsArray(
        filteredCarsArray.filter((item) => item.carName !== carName)
      );
    }
  };
  const setTagCarOnMap = (carNumber, gpsiCarId, carType) => {
    const exist = highlightCar.find((item) => item === carNumber);
    const exist2 = carsDataMessages.get().find((item) => item === carNumber);

    if (exist) {
      let newData = highlightCar.filter((item) => item !== carNumber);
      let newGpsData = highlightGpsiCarIds.filter((item) => item.gpsiCarId !== gpsiCarId);
      setHighlightCar(newData);
      setHighlightGpsiCarIds(newGpsData);
    } else {
      setHighlightCar([...highlightCar, carNumber]);
      setHighlightGpsiCarIds([...highlightGpsiCarIds, { gpsiCarId, carType }]);
    }

    if (exist2) {
      let newData = carsDataMessages.get().filter((item) => item !== carNumber);
      carsDataMessages.set(newData);
    } else {
      carsDataMessages.set([...carsDataMessages.get(), carNumber]);
    }
    showTaggedCar.set(carNumber);
  };

  const selectCarsData = (selectionType) => {
    if (selectionType === "all") {
      if (
        getSelectedCarsState.get() &&
        getSelectedCarsState.get().length !== 0
      ) {
        const carsData = JSON.parse(JSON.stringify(getSelectedCarsState.get()));
        const carsNumberData =
          carsData && carsData.length !== 0
            ? carsData.map((item) => {
              return item?.Car?.CarNumber;
            })
            : [];
        const carsGpsiIdData =
          carsData && carsData.length !== 0
            ? carsData.map((item) => {
              return item?.Car?.GpsiCarId;
            })
            : [];
        setHighlightCar([...carsNumberData]);
        setHighlightGpsiCarIds([...carsGpsiIdData]);
        carsDataMessages.set([...carsNumberData]);
      }
    } else {
      setHighlightCar([]);
      carsDataMessages.set([]);
      setHighlightGpsiCarIds([]);
    }
  };

  const setPresetMessage = (selectedItem, e) => {
    if (selectedItem) {
      setMessageInput(selectedItem.Body);
      setAlert(selectedItem.Audible);
      setPriority(selectedItem.Priority);
      setOkResponse(selectedItem.OkResponse);
      setYesNoResponse(selectedItem.YesNoResponse);
      if (!selectedItem.OkResponse && !selectedItem.YesNoResponse) {
        setNoneResponse(true);
      } else {
        setNoneResponse(false);
      }
      setShowPresetMessage(false);
    } else {
      setMessageInput(e.target.value);
    }
  };

  const sendMessageToCar = () => {
    var options = 0;
    if (priority) options |= 0x02;
    if (alert) options |= 0x04;
    if (okResponse) options |= 0x08;
    if (yesNoResponse) options |= 0x10;
    if (messageInput !== "" && highlightGpsiCarIds.length !== 0) {
      let data =
        highlightGpsiCarIds && highlightGpsiCarIds.length !== 0
          ? highlightGpsiCarIds.map((item, index) => {
            dispatch(
              COMMON_SERVICES.sendMessagesServices(
                messageInput,
                options,
                item?.gpsiCarId ? item.gpsiCarId.toString() : item,
                Number(siteId.get())
              )
            );
          })
          : "";
      showMessageWindowState.set(false);
    }
    setNoneResponse(true);
    setOkResponse(false);
    setYesNoResponse(false);
    setAlert(true);
    setPriority(true);
  };

  const handelResetMessage = () => {
    setMessageInput("");
    setSearchInput("");
    setPaceWarningState(false);
    setPaceCriticalState(false);
    setBatteryWarningState(false);
    setBatteryCriticalState(false);
    setFleetCars(true);
    setSpecialCars(true);
    enableMemberCar && setMemberCars(true);
    setMarshalCars(true);
    setBeverageCars(true);
    setNotInUseCars(true);
    setCarsNotCommunicating(true);
    setFilteredCarsArray([]);
    setPriority(false);
    setAlert(false);
    setNoneResponse(true);
    setOkResponse(false);
    setYesNoResponse(false);
  };

  const showPopupWindow = () => {
    showTagCarsState.set(false);
    showMessageWindowState.set(!showMessageWindowState.get());
  };

  return (
    <>
      {showMessageWindowState.get() && !isUserReadOnly(getUserRole?.Role) && (
        <SelectTagCar className="map-car-section">
          <div className="inner-wrapper">
            <div className="box-heading">
              <h5>{t("Message")}</h5>
              <div className="close-icon-wrapper-mobile">
                <CloseIcon width={22} height={22} onClick={showPopupWindow} />
              </div>
            </div>

            <div className="filter">
              <p>{t("Filters")}</p>
              <div>
                {carStatusData &&
                  carStatusData.map((item) => (
                    <Tooltip
                      title={
                        item.id === 1
                          ? t("Cars_Pace_Warning")
                          : item.id === 2
                            ? t("Cars_Pace_Critical")
                            : item.id === 3
                              ? t("Cars_Battery_Warning")
                              : t("Cars_Battery_Critical")
                      }
                      placement="top"
                      arrow
                    >
                      <button
                        key={item.id}
                        onClick={() => {
                          if (item.id === 1) {
                            setPaceWarningState(!paceWarningState);
                            if (!filteredData.includes(item.id)) {
                              filteredData.push(item.id);
                            } else {
                              const index = filteredData.indexOf(item.id);
                              filteredData.splice(index, 1);
                            }
                          } else if (item.id === 2) {
                            setPaceCriticalState(!paceCriticalState);
                            if (!filteredData.includes(item.id)) {
                              filteredData.push(item.id);
                            } else {
                              const index = filteredData.indexOf(item.id);
                              filteredData.splice(index, 1);
                            }
                          } else if (item.id === 3) {
                            setBatteryWarningState(!batteryWarningState);
                            if (!filteredData.includes(item.id)) {
                              filteredData.push(item.id);
                            } else {
                              const index = filteredData.indexOf(item.id);
                              filteredData.splice(index, 1);
                            }
                          } else {
                            setBatteryCriticalState(!batteryCriticalState);
                            if (!filteredData.includes(item.id)) {
                              filteredData.push(item.id);
                            } else {
                              const index = filteredData.indexOf(item.id);
                              filteredData.splice(index, 1);
                            }
                          }
                        }}
                      >
                        {item.iconName}
                      </button>
                    </Tooltip>
                  ))}
              </div>
            </div>
            <div className="white-filter">
              <Tooltip title={t("Fleet_cars")} placement="top" arrow>
                <button onClick={() => { showFilteredCars("fleetCars", carType.normal, fleetCars); setFleetCars(!fleetCars); }}>
                  <FilterCarIcon
                    bgcolor={
                      fleetCars
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                    color={
                      fleetCars
                        ? "var(--input-background)"
                        : "var(--text-secondary)"
                    }
                    border={fleetCars ? "#FFE500" : "#707374"}
                  />
                </button>
              </Tooltip>
              <Tooltip title={t("Special_needs_cars")} placement="top" arrow>
                <button onClick={() => { showFilteredCars("specialCars", carType.handicap, specialCars); setSpecialCars(!specialCars) }}>
                  <FilterFlagIcon
                    bgcolor={
                      specialCars
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                    color={specialCars ? "var(--input-background)" : "#0026AC"}
                    border={
                      specialCars
                        ? "var(--theme-background)"
                        : "var(--side-nav-btn-border-color)"
                    }
                  />
                </button>
              </Tooltip>
              <Tooltip title={t("Marshal_cars")} placement="top" arrow>
                <button onClick={() => { showFilteredCars("marshalCars", carType.marshal, marshalCars); setMarshalCars(!marshalCars) }}>
                  {" "}
                  <FilterShildIcon
                    bgcolor={
                      marshalCars
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                    color={marshalCars ? "var(--input-background)" : "#49B3E0"}
                    border={
                      marshalCars
                        ? "var(--theme-background)"
                        : "var(--side-nav-btn-border-color)"
                    }
                  />
                </button>
              </Tooltip>
              <Tooltip title={t("Beverage_cars")} placement="top" arrow>
                <button onClick={() => { showFilteredCars("beverageCars", carType.bevcart, beverageCars); setBeverageCars(!beverageCars) }}>
                  <FilterDineIcon
                    bgcolor={
                      beverageCars
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                    color={beverageCars ? "var(--input-background)" : "#229D08"}
                    border={
                      beverageCars
                        ? "var(--theme-background)"
                        : "var(--side-nav-btn-border-color)"
                    }
                  />
                </button>
              </Tooltip>
              {enableMemberCar && <><Tooltip title={t("Member_car")} placement="top" arrow>
                <button
                  onClick={() => { showFilteredCars("memberCars", carType.member, memberCars); setMemberCars(!memberCars) }
                  }
                >
                  <MembercarIcon
                    width={30}
                    height={30}
                    bg={
                      memberCars
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                    color={memberCars ? "var(--input-background)" : "#00A000"}
                    stroke={memberCars
                      ? "var(--theme-background)"
                      : "var(--side-nav-btn-border-color)"}
                  />

                </button>
              </Tooltip>
                <Tooltip title={t("Member_/_Special_Needs")} placement="top" arrow>
                  <button onClick={() => {
                    setMemberSpecialCars(!memberSpecialCars)
                  }}>
                   <div style={{display: "inline-flex", gap: 1}}>  <MembercarIcon
                      width={30}
                      height={30}
                      bg={
                        memberSpecialCars
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color={memberSpecialCars ? "var(--input-background)" : "#00A000"}
                      stroke={memberSpecialCars
                        ? "var(--theme-background)"
                        : "var(--side-nav-btn-border-color)"}
                    />
                    <SpecialNeedsIcon width={20} height={30}
                      bg={
                        memberSpecialCars
                          ? "var(--theme-background)"
                          : "#0026AC"
                      }
                    />
                    </div>
                  </button>
                </Tooltip></>}
              <Tooltip title={t("Cars_not_in_use")} placement="top" arrow>
                <button onClick={() => { showFilteredCars("notInUseCars", carType.notInUse, notInUseCars); setNotInUseCars(!notInUseCars) }}>
                  <FilterBlockIcon
                    bgcolor={
                      notInUseCars
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                    color={notInUseCars ? "var(--input-background)" : "#FA3C30"}
                    border={
                      notInUseCars
                        ? "var(--theme-background)"
                        : "var(--side-nav-btn-border-color)"
                    }
                  />
                </button>
              </Tooltip>
              <Tooltip
                title={t("Cars_not_communicating")}
                placement="top"
                arrow
              >
                <button
                  className={carsNotCommunicating ? "active not-com" : " not-com"}
                  onClick={() => { showFilteredCars("carsNotCommunicating", carType.notCommunicating, carsNotCommunicating); setCarsNotCommunicating(!carsNotCommunicating) }}
                >
                  <FilterTagsIcon
                    bgcolor={
                      carsNotCommunicating
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                    color={
                      carsNotCommunicating
                        ? "var(--input-background)"
                        : "#3134EB"
                    }
                    border={
                      carsNotCommunicating
                        ? "var(--theme-background)"
                        : "var(--side-nav-btn-border-color)"
                    }
                    fill={
                      carsNotCommunicating
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                  />
                </button>
              </Tooltip>
            </div>

            <div className="search-wrapper">
              <input
                placeholder={t("Search_car_no")}
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
              />
              <SearchIcon />
            </div>

            <div className="car-selection">
              <div className="car-count">
                <div>
                  <p onClick={() => selectCarsData("all")}>{t("All")}</p> I{" "}
                  <p onClick={() => selectCarsData("none")}>{t("None")}</p>
                </div>
                <div>
                  <span>
                    {highlightCar.length &&
                      getSelectedCarsState
                        .get()
                        .filter((data) =>
                          highlightCar.some((item) => item === data.Car.CarNumber)
                        )?.length
                      ? highlightCar.length &&
                      getSelectedCarsState
                        .get()
                        .filter((data) =>
                          highlightCar.some(
                            (item) => item === data.Car.CarNumber
                          )
                        )?.length
                      : 0}
                  </span>
                  &nbsp;
                  {highlightCar.length > 1
                    ? t("cars_selected")
                    : t("car_selected")}
                </div>
              </div>

              <div
                className="car-number"
                style={{
                  maxHeight: 116,
                  overflow: "auto",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "row",
                }}
              >
                {getSelectedCarsState.get() &&
                  getSelectedCarsState.get().length !== 0 ? (
                  getSelectedCarsState
                    .get()
                    .filter((item) => {
                      if (searchInput === "") {
                        return item.Car.CarNumber;
                      } else if (
                        item.Car.CarNumber.toString()
                          .toLowerCase()
                          .includes(searchInput.toLowerCase())
                      ) {
                        return item.Car.CarNumber;
                      }
                    })
                    .sort((a, b) => a.Car.CarNumber - b.Car.CarNumber)
                    .map((item, index) => (
                      <Tooltip
                        key={index}
                        title={item.Car.CarNumber.toString()}
                        placement="top"
                      >
                        <button
                          className={
                            highlightCar &&
                              highlightCar.length !== 0 &&
                              highlightCar.includes(item?.Car?.CarNumber)
                              ? "active"
                              : ""
                          }
                          onClick={() =>
                            setTagCarOnMap(
                              item.Car.CarNumber,
                              item.Car.GpsiCarId,
                              item.Car.CarType
                            )
                          }
                        >
                          {item.Car.CarNumber}
                        </button>
                      </Tooltip>
                    ))
                ) : (
                  <p>No car number found</p>
                )}
              </div>

              <MsgToCar>
                <div className="add-msg">
                  <p>{t("Preset_messages")}</p>
                  <PlusIcon
                    cursor="pointer"
                    onClick={() => setShowPresetMessage(!showPresetMessage)}
                  />
                </div>
                <div className="text-area">
                  <textarea
                    maxLength={182}
                    id="w3review"
                    name="w3review"
                    rows="4"
                    placeholder={t("Type_your_message")}
                    value={messageInput}
                    onChange={(e) => setPresetMessage("", e)}
                  ></textarea>
                </div>
                <div className="checkbox-wrapper">
                  <FormGroup row>
                    <Tooltip title={t("Set_message_priority")} placement="top">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={priority}
                            onChange={() => {
                              setPriority(!priority);
                            }}
                            inputProps={{ "aria-label": "controlled" }}
                            icon={<UnCheckIcon width={15} height={15} />}
                            checkedIcon={<CheckIcon width={15} height={15} />}
                          />
                        }
                        label={t("Priority")}
                      />
                    </Tooltip>
                    <Tooltip title={t("Set_sound_on_message")} placement="top">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={alert}
                            onChange={() => {
                              setAlert(!alert);
                            }}
                            inputProps={{ "aria-label": "controlled" }}
                            icon={<UnCheckIcon width={15} height={15} />}
                            checkedIcon={<CheckIcon width={15} height={15} />}
                          />
                        }
                        label={t("Alert")}
                      />
                    </Tooltip>
                  </FormGroup>
                </div>
                <div className="response-section">
                  <p>{t("Response")}</p>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="noneResponse"
                      control={
                        <Radio
                          icon={<RadioUncheckIcon width={15} height={15} />}
                          checkedIcon={
                            <RadioCheckIcon width={15} height={15} />
                          }
                          checked={noneResponse}
                          onChange={(e) => {
                            setNoneResponse(e.target.checked);
                            setOkResponse(!e.target.checked);
                            setYesNoResponse(!e.target.checked);
                          }}
                        />
                      }
                      label={t("None")}
                    />
                    <FormControlLabel
                      value="okResponse"
                      control={
                        <Radio
                          icon={<RadioUncheckIcon width={15} height={15} />}
                          checkedIcon={
                            <RadioCheckIcon width={15} height={15} />
                          }
                          onChange={(e) => {
                            setOkResponse(e.target.checked);
                            setNoneResponse(!e.target.checked);
                            setYesNoResponse(!e.target.checked);
                          }}
                          checked={okResponse}
                        />
                      }
                      label={t("Ok")}
                    />
                    <FormControlLabel
                      value="yesNoResponse"
                      control={
                        <Radio
                          icon={<RadioUncheckIcon width={15} height={15} />}
                          checkedIcon={
                            <RadioCheckIcon width={15} height={15} />
                          }
                          checked={yesNoResponse}
                          onChange={(e) => {
                            setYesNoResponse(e.target.checked);
                            setNoneResponse(!e.target.checked);
                            setOkResponse(!e.target.checked);
                          }}
                        />
                      }
                      label={t("Yes/No")}
                    />
                  </RadioGroup>
                  <div className="action-wrapper">
                    <button
                      disabled={buttonDetector}
                      style={{
                        cursor:
                          highlightCar && highlightCar.length !== 0
                            ? "pointer"
                            : "context-menu",
                      }}
                      className={
                        highlightCar && highlightCar.length !== 0
                          ? "active send-btn"
                          : "disabled send-btn"
                      }
                      onClick={sendMessageToCar}
                    >
                      {t("Send")}
                    </button>
                    <button
                      disabled={buttonDetector}
                      className={
                        highlightCar && highlightCar.length !== 0
                          ? " send-btn"
                          : "disabled send-btn"
                      }
                      onClick={handelResetMessage}
                    >
                      {t("Reset")}
                    </button>
                  </div>
                </div>
              </MsgToCar>
            </div>
          </div>
          {showPresetMessage && (
            <PresetMessages>
              <div>
                <div className="heading-section">
                  <p>{t("Preset_messages")}</p>
                  <CloseIcon
                    onClick={() => setShowPresetMessage(false)}
                    width={22}
                    height={22}
                    className="close-icon"
                  />
                </div>
                <ul>
                  {cannedMessagesData && cannedMessagesData.length !== 0 ? (
                    cannedMessagesData.map((item) => (
                      <li key={uuid()} onClick={() => setPresetMessage(item)}>
                        <span style={{ cursor: "pointer" }}>
                          <img src={MsgArrowIcon} alt="Msg-Arrow-Icon" />
                        </span>{" "}
                        {item.Body}
                      </li>
                    ))
                  ) : (
                    <div className="presetMessagesContainer">
                      No Preset Messages Found
                    </div>
                  )}
                </ul>
              </div>
            </PresetMessages>
          )}
        </SelectTagCar>
      )}
    </>
  );
};
